import { render, staticRenderFns } from "./forecast.specs.vue?vue&type=template&id=8835bdde&lang=pug"
import script from "./forecast.specs.vue?vue&type=script&lang=js"
export * from "./forecast.specs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports